var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "modal-class": "channex-sync-main",
        centered: "",
        "hide-header": "",
        "hide-footer": "",
        "no-close-on-esc": "",
      },
      model: {
        value: _vm.value_,
        callback: function ($$v) {
          _vm.value_ = $$v
        },
        expression: "value_",
      },
    },
    [
      _c("h6", { staticClass: "text-left font-weight-bold" }, [
        _vm._v("Units"),
      ]),
      _c("hr", { staticClass: "mt-1" }),
      _c(
        "b-row",
        { staticClass: "no-gutters" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    block: "",
                    variant: "outline-secondary",
                    disabled: "",
                  },
                },
                [_vm._v("Import Room Types from Channex")]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "mt-3", attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                {
                  attrs: { block: "", variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("sync-units")
                    },
                  },
                },
                [_vm._v("Send Units to Channex")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("h6", { staticClass: "text-left font-weight-bold mt-5" }, [
        _vm._v("Rates"),
      ]),
      _c("hr", { staticClass: "mt-1" }),
      _c(
        "b-row",
        { staticClass: "no-gutters" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                {
                  attrs: { block: "", variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("sync-rates")
                    },
                  },
                },
                [_vm._v("Send Rates to Channex")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("h6", { staticClass: "text-left font-weight-bold mt-5" }, [
        _vm._v("Bookings"),
      ]),
      _c("hr", { staticClass: "mt-1" }),
      _c(
        "b-row",
        { staticClass: "no-gutters" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                {
                  attrs: { block: "", variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("import-bookings")
                    },
                  },
                },
                [_vm._v("Import Bookings from Channex")]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "mt-3", attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                {
                  attrs: { block: "", variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("sync-avr")
                    },
                  },
                },
                [_vm._v("Send Availability to Channex")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "no-gutters mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { sm: "12" } },
            [
              _c(
                "b-btn",
                { attrs: { variant: "secondary" }, on: { click: _vm.onClose } },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }